import {alpha, FormControl, InputLabel, Select, SelectChangeEvent} from "@mui/material";
import {useTranslation} from "react-i18next";
import MenuItem from "@mui/material/MenuItem";
import {FC} from "react";
import Box from "@mui/material/Box";
import {TrendingFlat} from "@mui/icons-material";
import {useTheme} from "@mui/material/styles";

interface IProps {
    value: any
    handleSortingChange: (value: any) => void
    sortingMenuItems: { value: string | number, text: string }[]
}

const SortingSelect: FC<IProps> = (props) => {
    const {t} = useTranslation()
    const theme = useTheme()

    const handleSelectChange = (e: SelectChangeEvent<HTMLInputElement>) => {
        props.handleSortingChange(e.target.value);
    };

    return (
        <FormControl fullWidth size="small" sx={{maxWidth: {xs: '100%', sm: '320px'}}}>
            <InputLabel id="wish_categories">{t('sort_by')}</InputLabel>
            <Select
                value={props.value}
                onChange={handleSelectChange}
                variant="outlined"
                color="primary"
                label={t('sort_by')}
            >
                {props.sortingMenuItems.map((item, idx) => {
                    return [
                        <MenuItem
                            key={item.value + "-desc"}
                            value={item.value + ",desc"}
                        >
                            <Box display="flex" alignItems="center">
                                {item.text}
                                <TrendingFlat
                                    sx={{transform: "rotate(90deg)"}}
                                    fontSize="small"
                                />
                            </Box>
                        </MenuItem>,
                        <MenuItem
                            key={item.value + "-asc"}
                            sx={{
                                ...(idx !== props.sortingMenuItems.length - 1 && {
                                    borderBottom: `1px solid ${alpha(theme.palette.secondary.main, .2)}`,
                                }),
                            }}
                            value={item.value + ",asc"}
                        >
                            <Box display="flex" alignItems="center">
                                {item.text}
                                <TrendingFlat
                                    fontSize="small"
                                    sx={{transform: "rotate(-90deg)"}}
                                />
                            </Box>
                        </MenuItem>,
                    ];
                })}
            </Select>
        </FormControl>
    )
}

export default SortingSelect